import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-column">
            <h3 className="footer-title">Physiotherapie Grau</h3>
            <p className="footer-text">
              Ihre Physiotherapiepraxis in Apolda.<br />
              Familienbetrieb mit persönlicher Betreuung.
            </p>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Navigation</h4>
            <ul className="footer-links">
              <li><Link to="/">Start</Link></li>
              <li><Link to="/leistungen">Leistungen</Link></li>
              <li><Link to="/hausbesuche">Hausbesuche</Link></li>
              <li><Link to="/personal-training">Personal Training</Link></li>
              <li><Link to="/ueber-uns">Über uns</Link></li>
              <li><Link to="/kontakt">Kontakt</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Kontakt</h4>
            <ul className="footer-contact">
              <li>
                <Phone className="footer-icon" />
                <a href="tel:03644515313">03644 515313</a>
              </li>
              <li>
                <Mail className="footer-icon" />
                <a href="mailto:physio.grau@gmail.com">physio.grau@gmail.com</a>
              </li>
              <li>
                <MapPin className="footer-icon" />
                <span>Rosestraße 4<br />99510 Apolda</span>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Öffnungszeiten</h4>
            <div className="footer-hours">
              <div className="hours-row">
                <span className="hours-day">Montag - Freitag</span>
                <span className="hours-time">8:00 - 18:00 Uhr</span>
              </div>
              <p className="hours-note">Termine nach Vereinbarung</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; {new Date().getFullYear()} Physiotherapie Grau. Alle Rechte vorbehalten.
          </p>
          <div className="footer-legal">
            <Link to="/impressum">Impressum</Link>
            <Link to="/datenschutz">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;